import apply from './apply/store';
import auth from './auth/store';

export default {
  namespaced: true,
  modules: { apply, auth },
};
